<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-typewriter icon"></i>
        Escrever notícia
      </h1>
      <router-link :to="{ name: 'articleCreate' }">
        <PrimaryButton class="px-5" icon="fa-solid fa-arrow-right-long">Continuar</PrimaryButton>
      </router-link>
    </div>
  </div>


  <div class="align p-4 space_title">
    <div v-if="!loading || stepArticles.data.length" class="card">
      <div class="p-4" id="table_filter">
        <p>
          <i class="fa-regular fa-circle-info me-1"></i> Antes de escrever, faça uma busca para verificar se notícia já existe ou se está na fila como Pendente.
      </p>
        <InputText placeholder="Buscar" v-model="filter.search" />
      </div>
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Título</th>
            <th>Redator</th>
            <th>Status</th>
            <th>Site</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, key) in stepArticles.data" :key="key">
            <td>
              {{ article.title }}
            </td>
            <td>
              {{ article.author_name }}
            </td>
            <td>
              <span class="badge" :style="'background-color: ' + article.status_color">{{ article.status_name }}</span>
            </td>
            <td class="text-nowrap">
              {{ article.site_name }}
            </td>
            <td class="text-nowrap">
              {{ $dateFormat(article.updated_at) }}
            </td>
          </tr>

          <tr class="no_result" v-if="!stepArticles || (stepArticles.data && !stepArticles.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="stepArticles.meta.links" />

  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { useArticleStore } from '@/stores/ArticleStore'
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import axios from 'axios';

const loader = inject('$loader');
const loading = ref(false);

const articleStore = useArticleStore();
const { stepArticles, filter } = storeToRefs(articleStore);

const router = useRouter();
const route = useRoute();

onBeforeMount(() => {
  filter.value = {};

  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  loadStepArticles();
});

watch(() => route.query.page, () => {
  window.scrollTo(0, 0);
  loadStepArticles();
});

watch(() => filter.value.search, debounce(() => {
  const new_query = { ...route.query, page: 1, search: filter.value.search };
  router.push({ query: new_query }).then(() => {
    loadStepArticles();
  });
}, 500));

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

let cancelTokenSource = null;

async function loadStepArticles() {
  loader.show();
  loading.value = true;
  filter.value.page = parseInt(route.query.page);

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  let result = await articleStore.getStepArticles(cancelTokenSource);

  if(result.success){
    loader.hide();
    loading.value = false;
  }
}
</script>